export enum ContractStatus {
  active = 0,
  expired = 1,
}
